import { useEffect, useState } from 'react';
import { base44 } from '@/api/base44Client';

// Live count of inbound customer replies still waiting to be triaged, used for
// the admin navigation badge. Stays current via the entity subscription rather
// than polling. Returns 0 for non-admins (the entity is admin-only).
export default function useInboundEmailUnread(enabled = true) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    let cancelled = false;

    const load = async () => {
      try {
        const rows = await base44.entities.CustomerEmailLog.filter({
          direction: 'inbound',
          inbox_status: 'new',
        });
        if (!cancelled) setCount(rows?.length || 0);
      } catch {
        if (!cancelled) setCount(0);
      }
    };

    load();
    const unsubscribe = base44.entities.CustomerEmailLog.subscribe(() => load());
    return () => {
      cancelled = true;
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [enabled]);

  return count;
}